import { render, staticRenderFns } from "./InputColor.vue?vue&type=template&id=13d5db7e"
import script from "./InputColor.vue?vue&type=script&lang=js"
export * from "./InputColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports